import { jsapiMap } from '../constants/jsapi';
import { isUndefined, arrayToObject } from './index';

export const transformContext = (context) => {
  let name = context.name;
  let option = context.option;

  if (jsapiMap[name]) {
    const item = jsapiMap[name];
    if (item.replaceName) {
      name = item.replaceName;
    }
    if (item.replaceOptionKey) {
      for (let k in item.replaceOptionKey) {
        option[item.replaceOptionKey[k]] = option[k];
      }
    }
    if (item.overwriteOptionValue) {
      for (let k in item.overwriteOptionValue) {
        const v = item.overwriteOptionValue[k];
        if (!isUndefined(v)) {
          option[k] = v;
        }
      }
    }
    if (item.arrayToObject) {
      item.arrayToObject.forEach((key) => {
        option[key] = arrayToObject(option[key]);
      });
    }
  }

  return {
    name,
    option,
  };
};

interface Option {
  name: string;
}

export const transformResult = (res: any, opts: Option) => {
  if (opts.name === 'request') {
    res.data = JSON.stringify(res.data);
  }
  return res;
};
